import React from "react";
import styled from "styled-components";

import Image from "partials/Image";
import IconSelector from "partials/IconSelector";
import FavoriteButton from "partials/FavoriteButton";
import SmartLink from "partials/SmartLink";
import MobileLinkCard from "partials/MobileLinkCard";

import Media from "css/Media";

export const LinkCard = (props) => {
  const { item, isMobile } = props;

  return !isMobile ? (
    <Wrapper>
      <StyledFavoriteButton sort={item.type} item={item} hasBackground />
      <SmartLink to={item.link}>
        <StyledImage image={item.acf.image} background ratio='5:4' />
        <Title>
          <IconSelector
            icon={
              item.type === "dining"
                ? "bell"
                : item.type === "conference_venues"
                ? "user"
                : "calender"
            }
          />
          <span>{item.acf.title}</span>
        </Title>
      </SmartLink>
    </Wrapper>
  ) : (
    <MobileLinkCard item={item} />
  );
};

export default LinkCard;

const Wrapper = styled.div`
  position: relative;
`;

const StyledFavoriteButton = styled(FavoriteButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 2;
  top: 0;
  right: calc((100vw - 80px) / 100 * 8.8);
  width: 103.97px;
  height: 101.597px;
  right: calc((100vw - 80px) / 100 * 3.65);

  ${Media.greaterThan("m")`
        right: calc((100vw - 80px) / 100 * 2.59);
    `}
`;

const StyledImage = styled(Image)`
  margin-bottom: ${(props) => props.theme.spacing.contentM};

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }

  ${Media.greaterThan("m")`
        margin-bottom: ${(props) => props.theme.spacing.contentL};
    `}
`;

const Title = styled.div`
  display: flex;
  align-items: center;

  span {
    ${(props) => props.theme.fonts.h4}
  }
`;
